module.exports = __webpack_public_path__ + "static/img/platform-home2.6e90026.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/platform/platform-home2.png
// module id = 8YuN
// module chunks = 0